import { useQuery } from '@tanstack/react-query';
import * as Styles from './styles';
import { Alert } from '../../../../../components/alerts/Alert';
import { coreService } from '../../../../../services/core/core-service';
import { Link } from 'react-router-dom';
import { Magic } from '../../../../shared/components/Icons/Magic';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../../redux/selectors';

const { Container } = Styles;

export const AiContextAlert = () => {
  const user = useSelector(selectUser);

  const [hideMessage, setHideMessage] = useState(
    localStorage.getItem('hide-ai-context-message') === 'true',
  );

  const { data } = useQuery({
    enabled: !hideMessage,
    queryKey: ['ai-context'],
    queryFn: () => coreService.getCompanyContext(),
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  const shouldShowMessage = useMemo(() => {
    const userRole = user?.membership?.role;

    if (!userRole) {
      return false;
    }

    if (!data || hideMessage || userRole !== 'ADMIN') {
      return false;
    }

    return (
      data.aboutTheCompany === '' &&
      data.aboutTheProductOrService === '' &&
      data.competitors === '' &&
      data.goals === '' &&
      data.other === ''
    );
  }, [data, hideMessage, user]);

  return (
    <Container>
      {shouldShowMessage && (
        <Alert
          customIcon={<Magic style={{ fill: '#0675FC' }} />}
          title="Supercharge Your AI Insights"
          message={
            <div>
              <div>
                Adding context about your business will help UpdateAI generate even more precise AI
                insights about your customer interactions.
              </div>

              <div>
                You can provide this information by{' '}
                <Link to="/settings?tab=my-workspace" style={{ textDecoration: 'underline' }}>
                  clicking here
                </Link>
                .
              </div>
            </div>
          }
          variant="info"
          primaryAction={{
            label: "Don't show this message again",
            onClick: () => {
              setHideMessage(true);
              localStorage.setItem('hide-ai-context-message', 'true');
            },
          }}
        />
      )}
    </Container>
  );
};
